import { render, staticRenderFns } from "./SettingsTab.vue?vue&type=template&id=4d2a1a6a&scoped=true&"
import script from "./SettingsTab.vue?vue&type=script&lang=js&"
export * from "./SettingsTab.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTab.vue?vue&type=style&index=0&id=4d2a1a6a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2a1a6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d2a1a6a')) {
      api.createRecord('4d2a1a6a', component.options)
    } else {
      api.reload('4d2a1a6a', component.options)
    }
    module.hot.accept("./SettingsTab.vue?vue&type=template&id=4d2a1a6a&scoped=true&", function () {
      api.rerender('4d2a1a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/settings/SettingsTab.vue"
export default component.exports